export default __webpack_public_path__ + "images/candidates-card.dc647e777a37c39259f8.png";